import { render, staticRenderFns } from "./Units.vue?vue&type=template&id=2dd21f68&scoped=true"
import script from "./Units.vue?vue&type=script&lang=js"
export * from "./Units.vue?vue&type=script&lang=js"
import style0 from "./Units.vue?vue&type=style&index=0&id=2dd21f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd21f68",
  null
  
)

export default component.exports